export const Countries = [
  { code: "AF", label: "Afghanistan" },
  { code: "AL", label: "Albania" },
  { code: "DZ", label: "Algeria" },
  { code: "AS", label: "American Samoa" },
  { code: "AD", label: "Andorra" },
  { code: "AO", label: "Angola" },
  { code: "AI", label: "Anguilla" },
  { code: "AQ", label: "Antarctica" },
  { code: "AG", label: "Antigua & Barbuda" },
  { code: "AR", label: "Argentina" },
  { code: "AM", label: "Armenia" },
  { code: "AW", label: "Aruba" },
  { code: "AU", label: "Australia" },
  { code: "AT", label: "Austria" },
  { code: "AZ", label: "Azerbaijan" },
  { code: "BS", label: "Bahamas" },
  { code: "BH", label: "Bahrain" },
  { code: "BD", label: "Bangladesh" },
  { code: "BB", label: "Barbados" },
  { code: "BY", label: "Belarus" },
  { code: "BE", label: "Belgium" },
  { code: "BZ", label: "Belize" },
  { code: "BJ", label: "Benin" },
  { code: "BM", label: "Bermuda" },
  { code: "BT", label: "Bhutan" },
  { code: "BO", label: "Bolivia" },
  { code: "BA", label: "Bosnia & Herzegovina" },
  { code: "BW", label: "Botswana" },
  { code: "BV", label: "Bouvet Island" },
  { code: "BR", label: "Brazil" },
  { code: "IO", label: "British Indian Ocean Territory" },
  { code: "BN", label: "Brunei Darussalam" },
  { code: "BG", label: "Bulgaria" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BI", label: "Burundi" },
  { code: "KH", label: "Cambodia" },
  { code: "CM", label: "Cameroon" },
  { code: "CA", label: "Canada" },
  { code: "CV", label: "Cape Verde" },
  { code: "KY", label: "Cayman Islands" },
  { code: "CF", label: "Central African Republic" },
  { code: "TD", label: "Chad" },
  { code: "CL", label: "Chile" },
  { code: "CN", label: "China" },
  { code: "CX", label: "Christmas Island" },
  { code: "CC", label: "Cocos (Keeling) Islands" },
  { code: "CO", label: "Colombia" },
  { code: "KM", label: "Comoros" },
  { code: "CG", label: "Congo" },
  { code: "CD", label: "Zaire" },
  { code: "CK", label: "Cook Islands" },
  { code: "CR", label: "Costa Rica" },
  { code: "CI", label: "Cote D'ivoire (Ivory Coast)" },
  { code: "HR", label: "Croatia (Hrvatska)" },
  { code: "CU", label: "Cuba" },
  { code: "CY", label: "Cyprus" },
  { code: "CZ", label: "Czech Republic" },
  { code: "DK", label: "Denmark" },
  { code: "DJ", label: "Djibouti" },
  { code: "DM", label: "Dominica" },
  { code: "DO", label: "Dominican Republic" },
  { code: "TP", label: "East Timor" },
  { code: "EC", label: "Ecuador" },
  { code: "EG", label: "Egypt" },
  { code: "SV", label: "El Salvador" },
  { code: "GQ", label: "Equatorial Guinea" },
  { code: "ER", label: "Eritrea" },
  { code: "EE", label: "Estonia" },
  { code: "ET", label: "Ethiopia" },
  { code: "FK", label: "Falkland Islands (Malvinas)" },
  { code: "FO", label: "Faroe Islands" },
  { code: "FJ", label: "Fiji" },
  { code: "FI", label: "Finland" },
  { code: "FR", label: "France" },
  { code: "GF", label: "French Guiana" },
  { code: "PF", label: "French Polynesia" },
  { code: "TF", label: "French Southern Territories" },
  { code: "GA", label: "Gabon" },
  { code: "GM", label: "Gambia" },
  { code: "GE", label: "Georgia" },
  { code: "DE", label: "Germany" },
  { code: "GH", label: "Ghana" },
  { code: "GI", label: "Gibraltar" },
  { code: "GB", label: "United Kingdom" },
  { code: "GR", label: "Greece" },
  { code: "GL", label: "Greenland" },
  { code: "GD", label: "Grenada" },
  { code: "GP", label: "Guadeloupe" },
  { code: "GU", label: "Guam" },
  { code: "GT", label: "Guatemala" },
  { code: "GN", label: "Guinea" },
  { code: "GW", label: "Guinea-Bissau" },
  { code: "GY", label: "Guyana" },
  { code: "HT", label: "Haiti" },
  { code: "HM", label: "Heard & McDonald Islands" },
  { code: "VA", label: "Vatican City (Holy See)" },
  { code: "HN", label: "Honduras" },
  { code: "HK", label: "Hong Kong" },
  { code: "HU", label: "Hungary" },
  { code: "IS", label: "Iceland" },
  { code: "IN", label: "India" },
  { code: "ID", label: "Indonesia" },
  { code: "IR", label: "Iran" },
  { code: "IQ", label: "Iraq" },
  { code: "IE", label: "Ireland" },
  { code: "IL", label: "Israel" },
  { code: "IT", label: "Italy" },
  { code: "JM", label: "Jamaica" },
  { code: "JP", label: "Japan" },
  { code: "JO", label: "Jordan" },
  { code: "KZ", label: "Kazakhstan" },
  { code: "KE", label: "Kenya" },
  { code: "KI", label: "Kiribati" },
  { code: "KP", label: "Korea (North)" },
  { code: "KR", label: "Korea (South)" },
  { code: "KW", label: "Kuwait" },
  { code: "KG", label: "Kyrgyzstan" },
  { code: "LA", label: "Laos" },
  { code: "LV", label: "Latvia" },
  { code: "LB", label: "Lebanon" },
  { code: "LS", label: "Lesotho" },
  { code: "LR", label: "Liberia" },
  { code: "LY", label: "Libya" },
  { code: "LI", label: "Liechtenstein" },
  { code: "LT", label: "Lithuania" },
  { code: "LU", label: "Luxembourg" },
  { code: "MO", label: "Macau" },
  { code: "MK", label: "Macedonia" },
  { code: "MG", label: "Madagascar" },
  { code: "MW", label: "Malawi" },
  { code: "MY", label: "Malaysia" },
  { code: "MV", label: "Maldives" },
  { code: "ML", label: "Mali" },
  { code: "MT", label: "Malta" },
  { code: "MH", label: "Marshall Islands" },
  { code: "MQ", label: "Martinique" },
  { code: "MR", label: "Mauritania" },
  { code: "MU", label: "Mauritius" },
  { code: "YT", label: "Mayotte" },
  { code: "MX", label: "Mexico" },
  { code: "FM", label: "Micronesia" },
  { code: "MD", label: "Moldova" },
  { code: "MC", label: "Monaco" },
  { code: "MN", label: "Mongolia" },
  { code: "MS", label: "Montserrat" },
  { code: "MA", label: "Morocco" },
  { code: "MZ", label: "Mozambique" },
  { code: "MM", label: "Myanmar" },
  { code: "NA", label: "Namibia" },
  { code: "NR", label: "Nauru" },
  { code: "NP", label: "Nepal" },
  { code: "NL", label: "Netherlands" },
  { code: "AN", label: "Netherlands Antilles" },
  { code: "NC", label: "New Caledonia" },
  { code: "NZ", label: "New Zealand" },
  { code: "NI", label: "Nicaragua" },
  { code: "NE", label: "Niger" },
  { code: "NG", label: "Nigeria" },
  { code: "NU", label: "Niue" },
  { code: "NF", label: "Norfolk Island" },
  { code: "MP", label: "Northern Mariana Islands" },
  { code: "NO", label: "Norway" },
  { code: "OM", label: "Oman" },
  { code: "PK", label: "Pakistan" },
  { code: "PW", label: "Palau" },
  { code: "PA", label: "Panama" },
  { code: "PG", label: "Papua New Guinea" },
  { code: "PY", label: "Paraguay" },
  { code: "PE", label: "Peru" },
  { code: "PH", label: "Philippines" },
  { code: "PN", label: "Pitcairn" },
  { code: "PL", label: "Poland" },
  { code: "PT", label: "Portugal" },
  { code: "PR", label: "Puerto Rico" },
  { code: "QA", label: "Qatar" },
  { code: "RE", label: "Reunion" },
  { code: "RO", label: "Romania" },
  { code: "RU", label: "Russian Federation" },
  { code: "RW", label: "Rwanda" },
  { code: "SH", label: "St. Helena" },
  { code: "KN", label: "Saint Kitts & Nevis" },
  { code: "LC", label: "Saint Lucia" },
  { code: "PM", label: "St. Pierre & Miquelon" },
  { code: "VC", label: "St. Vincent & the Grenadines" },
  { code: "WS", label: "Samoa" },
  { code: "SM", label: "San Marino" },
  { code: "ST", label: "Sao Tome & Principe" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "SN", label: "Senegal" },
  { code: "SC", label: "Seychelles" },
  { code: "SL", label: "Sierra Leone" },
  { code: "SG", label: "Singapore" },
  { code: "SK", label: "Slovak Republic" },
  { code: "SI", label: "Slovenia" },
  { code: "SB", label: "Solomon Islands" },
  { code: "SO", label: "Somalia" },
  { code: "ZA", label: "South Africa" },
  { code: "GS", label: "S.Georgia & S.Sandwich Islands" },
  { code: "ES", label: "Spain" },
  { code: "LK", label: "Sri Lanka" },
  { code: "SD", label: "Sudan" },
  { code: "SR", label: "Suriname" },
  { code: "SJ", label: "Svalbard & Jan Mayen Islands" },
  { code: "SZ", label: "Swaziland" },
  { code: "SE", label: "Sweden" },
  { code: "CH", label: "Switzerland" },
  { code: "SY", label: "Syria" },
  { code: "TW", label: "Taiwan" },
  { code: "TJ", label: "Tajikistan" },
  { code: "TZ", label: "Tanzania" },
  { code: "TH", label: "Thailand" },
  { code: "TG", label: "Togo" },
  { code: "TK", label: "Tokelau" },
  { code: "TO", label: "Tonga" },
  { code: "TT", label: "Trinidad & Tobago" },
  { code: "TN", label: "Tunisia" },
  { code: "TR", label: "Turkey" },
  { code: "TM", label: "Turkmenistan" },
  { code: "TC", label: "Turks & Caicos Islands" },
  { code: "TV", label: "Tuvalu" },
  { code: "UG", label: "Uganda" },
  { code: "UA", label: "Ukraine" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "US", label: "United States" },
  { code: "UY", label: "Uruguay" },
  { code: "UZ", label: "Uzbekistan" },
  { code: "VU", label: "Vanuatu" },
  { code: "VE", label: "Venezuela" },
  { code: "VN", label: "Viet Nam" },
  { code: "VG", label: "Virgin Islands (British)" },
  { code: "VI", label: "Virgin Islands (U.S.)" },
  { code: "WF", label: "Wallis & Futuna Islands" },
  { code: "EH", label: "Western Sahara" },
  { code: "YE", label: "Yemen" },
  { code: "YU", label: "Yugoslavia" },
  { code: "ZM", label: "Zambia" },
  { code: "ZW", label: "Zimbabwe" }
];

export const Industries = [
  { id: 1, label: "Entertainment" },
  { id: 2, label: "Finance" },
  { id: 3, label: "Medical" },
  { id: 4, label: "Software" },
  { id: 5, label: "Education" },
  { id: 6, label: "Textile" },
  { id: 7, label: "Media and News" },
  { id: 8, label: "Food Processing" },
  { id: 9, label: "Hospitality" },
  { id: 10, label: "Construction" },
  { id: 11, label: "Law" },
  { id: 12, label: "Advertising" },
  { id: 13, label: "Other" }
];

export const statesOfIndia = [
  { id: 1, label: "Andhra Pradesh" },
  { id: 2, label: "Arunachal Pradesh" },
  { id: 3, label: "Assam" },
  { id: 4, label: "Bihar" },
  { id: 5, label: "Chhattisgarh" },
  { id: 6, label: "Goa" },
  { id: 7, label: "Gujarat" },
  { id: 8, label: "Haryana" },
  { id: 9, label: "Himachal Pradesh" },
  { id: 10, label: "Jharkhand" },
  { id: 11, label: "Karnataka" },
  { id: 12, label: "Kerala" },
  { id: 13, label: "Madhya Pradesh" },
  { id: 14, label: "Maharashtra" },
  { id: 15, label: "Manipur" },
  { id: 16, label: "Meghalaya" },
  { id: 17, label: "Mizoram" },
  { id: 18, label: "Nagaland" },
  { id: 19, label: "Odisha" },
  { id: 20, label: "Punjab" },
  { id: 21, label: "Rajasthan" },
  { id: 22, label: "Sikkim" },
  { id: 23, label: "Tamil Nadu" },
  { id: 24, label: "Telangana" },
  { id: 25, label: "Tripura" },
  { id: 26, label: "Uttar Pradesh" },
  { id: 27, label: "Uttarakhand" },
  { id: 28, label: "West Bengal" },
  { id: 29, label: "Andaman and Nicobar Islands" },
  { id: 30, label: "Chandigarh" },
  { id: 31, label: "Dadra and Nagar Haveli and Daman and Diu" },
  { id: 32, label: "Delhi" },
  { id: 33, label: "Jammu and Kashmir" },
  { id: 34, label: "Ladakh" },
  { id: 35, label: "Lakshadweep" },
  { id: 36, label: "Puducherry" },
  { id: 37, label: "Jharkhand" }
];

export const Languages = [
  { id: 0, label: "Telugu" },
  { id: 1, label: "Nishi" },
  { id: 2, label: "Adi" },
  { id: 3, label: "Apatani" },
  { id: 4, label: "Galo" },
  { id: 5, label: "Monpa" },
  { id: 6, label: "Assamese" },
  { id: 7, label: "Bodo" },
  { id: 8, label: "Karbi" },
  { id: 9, label: "Mising" },
  { id: 10, label: "Rabha" },
  { id: 11, label: "Bhojpuri" },
  { id: 12, label: "Maithili" },
  { id: 13, label: "Magahi" },
  { id: 14, label: "Angika" },
  { id: 15, label: "Chhattisgarhi" },
  { id: 16, label: "Konkani" },
  { id: 17, label: "Gujarati" },
  { id: 18, label: "Haryanvi" },
  { id: 19, label: "Hindi" },
  { id: 20, label: "Kangri" },
  { id: 21, label: "Santali" },
  { id: 22, label: "Kannada" },
  { id: 23, label: "Malayalam" },
  { id: 24, label: "Marathi" },
  { id: 25, label: "Meitei" },
  { id: 26, label: "Khasi" },
  { id: 27, label: "Garo" },
  { id: 28, label: "Mizo" },
  { id: 29, label: "Ao" },
  { id: 30, label: "Konyak" },
  { id: 31, label: "Angami" },
  { id: 32, label: "Chakhesang" },
  { id: 33, label: "Odia" },
  { id: 34, label: "Punjabi" },
  { id: 35, label: "Rajasthani" },
  { id: 36, label: "Nepali" },
  { id: 37, label: "Bhutia" },
  { id: 38, label: "Lepcha" },
  { id: 39, label: "Limbu" },
  { id: 40, label: "Tamil" },
  { id: 41, label: "Kokborok" },
  { id: 42, label: "Awadhi" },
  { id: 43, label: "Braj" },
  { id: 44, label: "Bundeli" },
  { id: 45, label: "Kannauji" },
  { id: 46, label: "Garhwali" },
  { id: 47, label: "Kumaoni" },
  { id: 48, label: "Bengali" },
  { id: 49, label: "English" }
];
